// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { namesRequested, namesRequestError, namesRequestSuccess } from './compare-footer.actions';
import { CompareNamesResponse } from '@coa/app/shared/select-items-shared/models/compare-stores.response';

export const STATE_NAME = 'compare-names';

export interface State {
  isLoading: boolean;
  isError: boolean;
  compareNamesResponse: CompareNamesResponse;
}

const initialState: State = {
  isLoading: false,
  isError: false,
  compareNamesResponse: undefined,
};

const reducer = createReducer(
  initialState,
  on(namesRequested, (state) => ({...state, compareNamesResponse: undefined, isLoading: true, isError: false})),
  on(namesRequestSuccess, (state, {compareNamesResponse}) => ({...state, compareNamesResponse, isLoading: false})),
  on(namesRequestError, (state) => ({...state, isLoading: false, isError: true})),
);

export function compareFooterReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

